/**
 * LAP (Loan Against Property) Insert API Service
 * Handles loan against property application submission
 *
 * Refactored from: 3in1cms/bajajfinserv-web/ui.solid/src/lib/connectionManager/lapInsertApi.ts
 */

import { getUtmParamsFromCookie } from "@repo/shared-utils/common-utils";
import { createErrorResponse } from "@repo/shared-utils/error-response";
import { getOrDefaultValue } from "@repo/shared-utils/insert-params";
import { request } from "../core/request";
import { LOAN_TYPES_MAPPING, OPERATION_IDS } from "./constants";
import { ILapInsertApiRequest, ILapInsertApiResponse } from "../types/lapInsertApiTypes";
import { IUTMParams } from "../types/utmTypes";

export const lapInsert = async (data: ILapInsertApiRequest): Promise<ILapInsertApiResponse> => {
  try {
    const utm = getUtmParamsFromCookie() as IUTMParams;
    const reqData = {
      ...data,
      loanVariant: LOAN_TYPES_MAPPING[data?.loanVariant] ?? "",
      utmContent: getOrDefaultValue(utm?.utmContent),
      utmSource: getOrDefaultValue(utm?.utmSource),
      utmCampaign: getOrDefaultValue(utm?.utmCampaign),
      utmMedium: getOrDefaultValue(utm?.utmMedium),
    };
    const response = (await request({
      operationId: OPERATION_IDS.lapInsert,
      requestData: { ...reqData },
    })) as ILapInsertApiResponse;
    return response;
  } catch (error) {
    return createErrorResponse<ILapInsertApiResponse>(
      { id: "" } as ILapInsertApiResponse,
      "Failed to insert LAP data",
      "7002",
      "E",
      "LAP insert operation failed"
    );
  }
};
